export default __webpack_public_path__ + "static/media/y_wdt_c_0.db728ed0.mp3";